import { Navigate, useParams } from "react-router-dom";

/**
 * Carries a pre-rename `/thresholding/:event_name` link over to `/my-maps`.
 *
 * A bare `<Navigate>` cannot do it: the folder name is a route param, and
 * dropping it would land an emailed link on the list rather than the map it
 * names. Lives in its own module rather than inside the route table so it can
 * be tested without importing every page in the app.
 *
 * The auth gate runs first, and it stores the *pre-redirect* path as
 * `intendedRoute` — so a logged-out responder following an old link goes to
 * login, returns to `/thresholding/<folder>`, and only then lands here. Both
 * hops survive.
 */
const LegacyThresholdingRedirect = () => {
  const { event_name } = useParams();

  // Nothing to carry over. Send them to the list rather than to `/my-maps/`
  // with a trailing slash, which matches no route and would 404.
  if (!event_name) return <Navigate to="/my-maps" replace />;

  return <Navigate to={`/my-maps/${event_name}`} replace />;
};

export default LegacyThresholdingRedirect;
